import React from 'react';
import { withRequestedTradesContainer } from '../../../containers/default/saleTrade/RequestedTradesContainer';
import RequestedTradesTable from './RequestedTradesTable';

const RequestedTrades = ({ sales }) => {
  return (
    <div className="contracts-layout-content">
      <RequestedTradesTable sales={sales} />
    </div>
  );
};

export default withRequestedTradesContainer(RequestedTrades);
